import { plural } from "./usedBySummary";

export type SaveSummaryArgs = {
  store: string;
  field: string;
  targetName: string | null;
  link: boolean;
  total: number;
  ignored: number;
  needLook: number;
  valuesUnmapped: boolean;
};

export function saveSummary(a: SaveSummaryArgs): string[] {
  if (!a.targetName) return ["Pick a field in step 1 first."];
  const kept = a.total - a.ignored;
  const values =
    a.total > 0
      ? `${plural(kept, "value")} ${kept === 1 ? "is" : "are"} saved${a.ignored ? `, ${a.ignored} ignored` : ""}.${a.needLook ? ` ${a.needLook} still need${a.needLook === 1 ? "s" : ""} a look.` : ""}`
      : a.valuesUnmapped
        ? "Values are not mapped yet."
        : "No list of values.";
  return [
    `${a.store} “${a.field}” fills ${a.targetName}.`,
    values,
    a.link
      ? "Nothing is copied. Each store keeps its own answer."
      : "Only this store uses this answer for now.",
  ];
}
